// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 805) return "js/805-7a91c217d40b3301c805.js";
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"122":"a4954ca56d47086d5872","228":"c28d84cab66df7a3ab82"}[chunkId] + ".chunk.js";
};